<template lang="pug">
  div
    table.table.table-striped.table-bordered
      tr
        td Номер акта
        td {{formatAnswer(data.body.content.number, 2)}}
      tr
        td Дата и точное время начала медицинского освидетельствования
        td
          span(v-if="data.body.content.started_at!==undefined") {{data.body.content.started_at | datetime}}
          span(v-if="data.body.content.started_at===undefined") —

      tr
        td Внешний вид освидетельствуемого (наличие видимых повреждений, следов от инъекций)
        td {{formatAnswer(data.body.content.appearance, 2)}}
      tr
        td Жалобы освидетельствуемого на свое состояние
        td {{formatAnswer(data.body.content.complaints, 2)}}
      tr
        td Изменения психической деятельности освидетельствуемого
        td {{formatAnswer(data.body.content.mental_activity_changes, 2)}}
      tr
        td Результат пробы Шульте
        td {{formatAnswer(data.body.content.schulte_test, 2)}}
      tr
        td Вегетативно-сосудистые реакции освидетельствуемого
        td {{formatAnswer(data.body.content.vegetovascular_reactions, 2)}}
      tr
        td Зрачки
        td {{formatAnswer(data.body.content.pupils, 2)}}
      tr
        td Реакция на свет
        td {{formatAnswer(data.body.content.reaction_to_light, 2)}}
      tr
        td Склеры
        td {{formatAnswer(data.body.content.sclera, 2)}}
      tr
        td Нистагм
        td {{formatAnswer(data.body.content.nystagmus, 2)}}
      tr
        td Двигательная сфера освидетельствуемого
        td {{formatAnswer(data.body.content.motor_cortex, 2)}}
      tr
        td Речь
        td {{formatAnswer(data.body.content.speech, 2)}}
      tr
        td Походка
        td {{formatAnswer(data.body.content.gait, 2)}}
      tr
        td Устойчивость в позе Ромберга
        td {{formatAnswer(data.body.content.romberg_position, 2)}}
      tr
        td Точность выполнения координационных проб
        td {{formatAnswer(data.body.content.coordination_samples, 2)}}
      tr
        td Результат пробы Ташена
        td {{formatAnswer(data.body.content.tashen_test, 2)}}
      tr
        td Наличие заболеваний нервной системы, психических расстройств, перенесенных травм (со слов освидетельствуемого)
        td {{formatAnswer(data.body.content.diseases, 2)}}
      tr
        td Сведения о последнем употреблении алкоголя, лекарственных средств, наркотических средств и психотропных веществ (со слов освидетельствуемого)
        td {{formatAnswer(data.body.content.abuse_info, 2)}}

    h5 Наличие алкоголя в выдыхаемом воздухе освидетельствуемого
    table.table.table-striped.table-bordered
      tr
        td Время первого исследования, наименование технического средства измерения, его заводской номер, дата последней поверки, погрешность технического средства измерения, результат исследования
        td {{data.body.content.alcohol_analysis ? formatAnswer(data.body.content.alcohol_analysis.first_study, 2) : "—"}}
      tr
        td Второе исследование через 15 - 20 минут: время исследования, результат исследования (наименование технического средства измерения, его заводской номер, дата последней поверки, погрешность технического средства измерения указываются в случае использования другого технического средства измерения)
        td {{data.body.content.alcohol_analysis ? formatAnswer(data.body.content.alcohol_analysis.second_study, 2) : "—"}}

    table.table.table-striped.table-bordered
      tr
        td Вид биологического объекта
        td {{formatAnswer(data.body.content.analysis_type, 2)}}
      tr
        td Время отбора биологического объекта у освидетельствуемого
        td
          span(v-if="data.body.content.sampling_date!==undefined") {{data.body.content.sampling_date | datetime}}
          span(v-if="data.body.content.sampling_date===undefined") —
      tr
        td Результаты химико-токсикологических исследований биологических объектов (название лаборатории, методы исследований, результаты исследований, номер справки о результатах химико-токсикологических исследований)
        td {{formatAnswer(data.body.content.HTI_results, 2)}}
      tr
        td Другие данные медицинского осмотра или представленных документов (указать, какие, дату проведенных медицинских вмешательств)
        td {{formatAnswer(data.body.content.other_data, 2)}}
      tr
        td Дата и точное время окончания медицинского освидетельствования
        td
          span(v-if="data.body.content.ended_at!==undefined") {{data.body.content.ended_at | datetime}}
          span(v-if="data.body.content.ended_at===undefined") —

      tr
        td Медицинское заключение
        td {{formatAnswer(data.body.content.conclusion, 2)}}
</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type, units) {
      switch (type) {
        case 1:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
